import React from 'react'
import DetailDataTableCell from './DetailDataTableCell'

export default function DetailDataTableRow(props) {
    const { coltype, columns, item, rowno, ...rest } = props
    return (
        <tr>
            {columns && columns.map((col, idx) =>
                col in coltype &&
                <td key={"cell-" + col + "-" + rowno + "-" + idx}
                    style={{
                        textAlign: coltype[col].align ? coltype[col].align : "left",
                        verticalAlign:"middle"
                    }}
                >

                    {col === 'no'
                        ? rowno
                        : <DetailDataTableCell item={item} idx={rowno - 1} colname={col} coltype={coltype[col]} {...rest} />
                    }

                </td>
            )}
        </tr>
    )
}
